/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { baseURL } from "utils/api";
import axios from "axios";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import { useState } from "react";
// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import Button from "../../components/ButtonUse.jsx";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

// Data

// Dashboard components

function AddNewShop() {
  const navigate = useNavigate();
  const [formState, setFormState] = useState({
    venderId: "",
    companyName: "",
    sid: "",
    goodsAddress: "",
  });

  const handleUploadStore = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/upload/store`, {
        ...formState,
      });
      navigate("/Shops");
      console.log(res);
    } catch (error) {
      console.error(error);
    }
  };
  // ---------------------------------POST API------------------------------------//
  const [file, setFile] = useState();
  const [vendorId, setVendorId] = useState();
  const [companyName, setCompanyName] = useState();
  const [goodsAddress, setGoodsAddress] = useState("");
  const [sid, setSid] = useState("");

  async function saveData() {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("venderId", vendorId);
    formData.append("companyName", companyName);
    formData.append("goodsAddress", goodsAddress);
    formData.append("sid", sid);

    try {
      let result = await fetch("${process.env.REACT_APP_BASE_URL}/store/addStore", {
        method: "POST",
        body: formData,
      });
      if (result.ok) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Data has been posted successfully!",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            // Navigate to another page
            window.location.href = "/Shops";
          }
        });
        setFile("");
        setVendorId("");
        setCompanyName("");
        setGoodsAddress("");
        setSid("");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to post data. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error posting data:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred while posting data. Please try again later.",
      });
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <form
          style={{
            background: "white",
            padding: "10px",
            borderRadius: "10px",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          }}
          autoComplete="off"
          onSubmit={handleUploadStore}
        >
          <div style={{ padding: "5px" }}>
            <div style={{ display: "flex", gap: "40px" }}>
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Veondor ID*"
                variant="outlined"
                // value={formState.venderId}
                // onChange={(e) => setFormState({ ...formState, venderId: e.target.value })}
                value={vendorId}
                className="form-control"
                onChange={(e) => {
                  setVendorId(e.target.value);
                }}
                required
              />

              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="Company Name*"
                variant="outlined"
                // value={formState.companyName}
                // onChange={(e) => setFormState({ ...formState, companyName: e.target.value })}
                value={companyName}
                className="form-control"
                onChange={(e) => {
                  setCompanyName(e.target.value);
                }}
                required
              />
              <TextField
                id="outlined-basic"
                sx={{ width: "20vw" }}
                label="SID value*"
                variant="outlined"
                // value={formState.sid}
                // onChange={(e) => setFormState({ ...formState, sid: e.target.value })}
                value={sid}
                className="form-control"
                onChange={(e) => {
                  setSid(e.target.value);
                }}
                required
              />
            </div>
            <div style={{ marginTop: "10vh" }}>
              <div style={{ display: "flex", gap: "40px" }}>
                <TextField
                  id="outlined-basic"
                  sx={{ width: "20vw" }}
                  label="Send goods Address*"
                  variant="outlined"
                  // value={formState.goodsAddress}
                  // onChange={(e) => setFormState({ ...formState, goodsAddress: e.target.value })}
                  value={goodsAddress}
                  className="form-control"
                  onChange={(e) => {
                    setGoodsAddress(e.target.value);
                  }}
                  required
                />

                {/* <TextField
                  id="outlined-basic"
                  sx={{ width: "20vw" }}
                  label="Image*"
                  variant="outlined"
                  value={formState.goodsAddress}
                  onChange={(e) => setimage(e.target.files[0])}
                /> */}

                <TextField
                  type="file"
                  className="form-control"
                  onChange={(e) => setFile(e.target.files[0])}
                />
              </div>
            </div>
          </div>
          <div style={{ textAlign: "center", color: "red", marginTop: "20px" }}>
            <span
              className="bg-red-700 rounded-md w-[10vw] cursor-pointer
                p-2 border-none outline-none ml-[1vw] text-white  text-sm"
              onClick={saveData}
            >
              Submit
            </span>
          </div>
        </form>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddNewShop;
